import React from "react";
import MonthlyTimeTable from "../MonthlyTimeTable";

const NovemberSehriIftaar = ({districtDetails}) => {
  return <MonthlyTimeTable month={11} title="November Sehri Iftar" columnKey="3Columns" districtDetails={districtDetails} />;
};

export default NovemberSehriIftaar;
